(function($) {
	$(document).ready(function(){
		$('#cat').change(function() {
			var that = $(this)[0];
			window.document.location.href='/product-category/' + that.options[that.selectedIndex].value;
		});
	});
})(jQuery); // Fully reference jQuery after this point.